// Created by carsonaberle at 5/14/22
import React, { useState } from 'react';
import * as S from './styles';
import { LC_FLOOR_PLANS, LC_MATTERPORT, LC_PHOTOS, LC_VIDEO } from './config';
import ListingPhotos from '../ListingPhotos';
import ListingVideos from '../ListingVideos';
import ListingFloorPlans from '../ListingFloorplans';
import ListingMatterports from '../ListingMatterport';
import UIDropdownSelect from '../../../../../components/UI/UIDropdownSelect';

export default function ListingContent({ listingId }: ListingContentProps) {
	const tabs = [LC_PHOTOS, LC_VIDEO, LC_FLOOR_PLANS, LC_MATTERPORT];

	const [selectedTab, setSelectedTab] = useState<PLTab>(tabs[0]);

	const renderSelectedSegment = () => {
		switch (selectedTab.value) {
			case LC_PHOTOS.value:
				return <ListingPhotos listingId={listingId} />;
			case LC_VIDEO.value:
				return <ListingVideos listingId={listingId} />;
			case LC_FLOOR_PLANS.value:
				return <ListingFloorPlans listingId={listingId} />;
			case LC_MATTERPORT.value:
				return <ListingMatterports listingId={listingId} />;
			default:
				return null;
		}
	};
	return (
		<S.div_ListingContentContainer>
			<S.div_ListingContentTabBar>
				<UIDropdownSelect selectedTab={selectedTab} tabs={tabs} updateSelected={setSelectedTab} />
			</S.div_ListingContentTabBar>
			<S.div_ListingContentPage>{renderSelectedSegment()}</S.div_ListingContentPage>
		</S.div_ListingContentContainer>
	);
}
